import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var IndesignShortcutSvg = function IndesignShortcutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#49021F",
    fillRule: "evenodd",
    d: "M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H8.708A9 9 0 0 0 0 9.223V2a2 2 0 0 1 2-2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F36",
    fillRule: "evenodd",
    d: "M8.703 11.994V6.878H7.002v3.639c.627.42 1.199.917 1.701 1.477m7.112 3.522c-.224.693-.833 1.624-2.38 1.624-1.918 0-3.073-1.365-3.073-3.794 0-2.261 1.008-3.724 2.919-3.724 1.19 0 1.974.644 2.268 1.197V6.598h1.715V17h-1.26zm-3.766-2.212c0 1.701.63 2.583 1.736 2.583 1.225 0 1.764-.735 1.764-2.583-.014-1.575-.539-2.415-1.743-2.415-1.029 0-1.757.707-1.757 2.415",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var IndesignShortcut = function IndesignShortcut(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: IndesignShortcutSvg
  }));
};